<template>
  <div class="sketch-divider" aria-hidden="true">
    <svg viewBox="0 0 220 18" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M2 10C28 4 48 14 74 9s42-8 68-1 40 8 64 0 14-4 20-2"
        stroke="currentColor"
        stroke-width="1.4"
        stroke-linecap="round"
      />
      <circle cx="110" cy="9" r="2" fill="currentColor" opacity="0.55" />
    </svg>
  </div>
</template>

<script>
export default {
  name: "SketchDivider",
};
</script>
